import React from 'react';

import styled from 'styled-components';

import { Tag } from '@dev/ee-components';

import { CustomPopoverBodyProps } from '../../../../SettingsAndTrackingInterface';

const FilterContainer = styled.div`
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
`;

const FilterLabel = styled.span`
    margin: 0 1em;
    display: flex;
    align-items: center;
`;

export const CustomPopoverBody = (props: CustomPopoverBodyProps): JSX.Element => {
    const { element } = props;
    return (
        <FilterContainer>
            <FilterLabel>{element?.label}</FilterLabel>
            <Tag label={element.count} clickable={false} />
        </FilterContainer>
    );
};
